import React, { useState, useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, Header, FilePicker } from 'components';
import {
	Card,
	CardHeader,
	CardContent,
	TextField,
	Grid,
	Button,
	colors,
	Autocomplete,
	Divider
} from '@mui/material';
import { enqueueSnackbar } from 'actions';
import { SetFormState, GetDss2100Scripts, SendDss2100EricssonFileAndSites } from '../../actions/ScriptingActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const Dss2100Scripting = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.scriptingReducer.formState);

	const scripts = useSelector(state => state.scriptingReducer.scripts);
	const [sites, setSites] = useState();
	const [sitesEricsson, setSitesEricsson] = useState();

	const _handleSitesChange = event => {
		setSites(event.target.value);
	};
	const _getDss2100Scripts = () => {
		dispatch(GetDss2100Scripts(sites));
	};

	const _onChangeInput = (event) => {
		if (event.target.files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
			if (event.target.files && event.target.files.length > 0) {
				const file = event.target.files[0];
				setFormState({
					...formState,
					values: {
						...formState.values,
						dssEricssonExcelInputFilePath: file
					}
				});
			}
		} else {
			dispatch(enqueueSnackbar({ message: 'File type not supported', options: { variant: 'warning' } }));
		}
	};

	const _handleSitesEricssonChange = event => {
		setSitesEricsson(event.target.value);
	};

	const _getDss2100EricssonScripts = (event) => {
		if (formState.values.dssEricssonExcelInputFilePath.size > 50000000) {
			dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 50MB', options: { variant: 'warning' } }));
		} else if (formState.values.dssEricssonExcelInputFilePath === '') {
			dispatch(enqueueSnackbar({ message: 'No file selected', options: { variant: 'Info' } }));
		} else {
			dispatch(SendDss2100EricssonFileAndSites(formState.values.dssEricssonExcelInputFilePath, sitesEricsson));
		}
	};

	return (
		<Page className={classes.root} title="Scripting">
			<Header module="Scripting" view="DSS 2100 Scripting" />
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardHeader title="Huawei" />
					<Divider />
					<CardContent>
						<Grid container spacing={2}>
							<Grid item md={8} xs={8}>
								<TextField
									fullWidth
									label="Sites"
									placeholder="Example: Site1,Site2,Site3"
									name="sites"
									onChange={_handleSitesChange}
									value={sites}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={4} xs={4}>
								<Button
									color="primary"
									variant="contained"
									size="large"
									onClick={_getDss2100Scripts}
								>
									Get Scripts
								</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
				<Card className={classes.container}>
					<CardHeader title="Ericsson" />
					<Divider />
					<CardContent>
						<Grid container spacing={2}>
							<Grid item md={8} xs={8}>
								<TextField
									fullWidth
									label="Sites"
									placeholder="Example: Site1,Site2,Site3"
									name="sitesEriccson"
									onChange={_handleSitesEricssonChange}
									value={sites}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={2} xs={2}>
								<FilePicker
									placeholder="Please select a pdf to upload"
									accept=".xlsx"
									onChange={_onChangeInput}
									value={formState.values.dssEricssonExcelInputFilePath?.name || ''}
								/>
							</Grid>
							<Grid item md={2} xs={2}>
								<Button
									color="primary"
									variant="contained"
									size="large"
									onClick={_getDss2100EricssonScripts}
								>
									Get Scripts
								</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default Dss2100Scripting;
